import { Controller } from "@hotwired/stimulus";

// Toggles the visibility of the "Unarchive selected" option based on
// whether any currently-checked checkboxes have data-archived="true".
export default class extends Controller {
  static targets = ["unarchiveAction"];

  connect() {
    this._observer = new MutationObserver(() => this._sync());
    const bulkSelect = this.element.closest("[data-controller~='ui--bulk-select']");
    if (bulkSelect) {
      this._observer.observe(bulkSelect, {
        subtree: true,
        attributes: true,
        attributeFilter: ["checked"],
      });
      // Also listen for click events to catch checkbox changes
      this._clickHandler = () => requestAnimationFrame(() => this._sync());
      bulkSelect.addEventListener("change", this._clickHandler);
      this._bulkSelect = bulkSelect;
    }
    this._sync();
  }

  disconnect() {
    if (this._observer) this._observer.disconnect();
    if (this._bulkSelect && this._clickHandler) {
      this._bulkSelect.removeEventListener("change", this._clickHandler);
    }
  }

  _sync() {
    if (!this.hasUnarchiveActionTarget) return;
    if (!this._bulkSelect) return;

    // In "select all" mode, archived items on other pages may be included,
    // so always show unarchive if any archived rows exist in the DOM.
    const allSelected = this._bulkSelect.querySelector(
      "[data-ui--bulk-select-target='allSelected']:not(.hidden)"
    );
    if (allSelected) {
      const anyArchivedInDom = this._bulkSelect.querySelector(
        "input[type='checkbox'][data-ui--bulk-select-target='checkbox'][data-archived='true']"
      );
      this.unarchiveActionTarget.classList.toggle("hidden", !anyArchivedInDom);
      return;
    }

    const checkedInputs = this._bulkSelect.querySelectorAll(
      "input[type='checkbox'][data-ui--bulk-select-target='checkbox']:checked"
    );

    const hasArchived = Array.from(checkedInputs).some(
      (input) => input.dataset.archived === "true"
    );

    this.unarchiveActionTarget.classList.toggle("hidden", !hasArchived);
  }
}
